import { FeatureFlag } from '@ps/web-core-enums';
import { type RootState, select } from '@ps/web-core-store';
import { createSelector } from '@rematch/select';
import type { Selector } from 'react-redux';

import { withEventBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/eventBased';

import { defaultState } from './defaultState';
import type { SportsHomePageState } from './types';

export const selectors = withEventBasedMarketTemplateModelSelectors(defaultState, (slice) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  hasErrored: () => slice((state) => state.error),
  popularBetBuilders: () => slice((state) => state.popularBetBuilders),
  hasPopularBetBuilders(this: {
    popularBetBuilders: Selector<RootState, SportsHomePageState['popularBetBuilders']>;
  }) {
    return createSelector(
      this.popularBetBuilders,
      (rootState: RootState) =>
        select.feature.check(rootState, FeatureFlag.ISPEnableHomePagePopularBetBuilders),
      (ppb, isPopularBetBuildersEnabled): boolean =>
        Boolean(isPopularBetBuildersEnabled && ppb.length)
    );
  },
  popularAccumulators: () => slice((state) => state.popularAccumulators),
  hasPopularAccumulators: () => slice((state) => Boolean(state.popularAccumulators.length))
}));
